import { Transition } from "@headlessui/react";
import React, { useEffect, useState } from "react";

const CustomAlert = ({ type, children, className }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setVisible(true);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    let bgColor = "bg-green-300";
    let textColor = "text-green-800";
    let borderColor = "green-400";

    switch (type) {
        case "danger":
            bgColor = "bg-red-300";
            textColor = "text-red-800";
            borderColor = "red-400";
            break;

        case "warning":
            bgColor = "bg-yellow-300";
            textColor = "text-yellow-800";
            borderColor = "yellow-400";
            break;

        case "info":
            bgColor = "bg-green-300";
            textColor = "text-green-800";
            borderColor = "green-400";
            break;

        default:
            break;
    }

    return (
        <>
            <Transition
                show={true}
                enter="transition ease-out duration-200"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <div
                    className={`duration-500 ${
                        visible ? "opacity-100" : "opacity-0"
                    } rounded border shadow ${bgColor} ${textColor} border-${borderColor} items-center bg-opacity-25 px-10 py-5 text-left ${className} text-sm`}
                >
                    {children}
                </div>
            </Transition>
        </>
    );
};

export default CustomAlert;
